import { render, staticRenderFns } from "./DoubleFlag.vue?vue&type=template&id=7c9393e2"
import script from "./DoubleFlag.vue?vue&type=script&lang=js"
export * from "./DoubleFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports